import { classes } from "@shared/api/services"
import { useInfiniteQuery } from "@tanstack/react-query"

export const useAppointmentsHistory = () => {
	return useInfiniteQuery({
		queryKey: ['history'],
		queryFn: ({ pageParam }) => classes.getHistory(pageParam),
		initialPageParam: 1,
		getNextPageParam: (lastPage) => {
			const body = lastPage?.data
			const current = body?.current_page ?? body?.meta?.current_page ?? 1
			const last = body?.last_page ?? body?.meta?.last_page ?? 1
			return current < last ? current + 1 : undefined
		},
	})
}
